// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 4826 ? "index" : chunkId) + "." + {"4826":"0c266bf3af1398ebe5d1","9854":"ec8f3a54da3fd5890dac"}[chunkId] + ".css";
};